import script from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KMenu\\KMenuItem.vue?type=script"
export * from "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KMenu\\KMenuItem.vue?type=script"

import "D:\\Kryzalis\\mpardini.com.br\\src\\assets\\js\\layout\\KMenu\\KMenuItem.vue?type=style&index=0"
export default script